import React from 'react';
import { useTranslation } from 'react-i18next';
import {Box} from "@mui/material";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  return (
      <Box
          component="footer"
          sx={{
              py: 2, // equal vertical padding (top and bottom)
              textAlign: 'center',
              backgroundColor: '#111827EA', // custom background color
              color: 'white',
          }}
      >
          {t('footer.copyright', {
              year,
          })}
      </Box>
  );
};

export default Footer;